/* ajustes-1-3-0, Bloque F (ajustes 16 y 17, 25-sep-2026): EL ANCHO DE UNA CAJA, MEDIDO.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Dos renglones del profe cambian su texto por el ancho que les toca: el cuadro de buscar
   grupos (menos de 200 px: "Buscar grupo") y el boton de YouTube (menos de 420 px de
   renglon: "Agregar"). Se mide con `ResizeObserver` y no con clases de contenedor
   de estilo: la hoja de Tailwind de la casa no trae el plugin de consultas de contenedor,
   y una consulta de medio miraria la VENTANA, no la caja, que es lo que aqui importa (el cuadro comparte renglon con un boton de ancho natural).

   Contrato: devuelve 0 hasta la primera medida (o cuando no hay caja). Quien lo use trata el
   0 como "todavia no se sabe" y pinta el texto largo, que es el de siempre: asi el primer
   cuadro no parpadea del corto al largo. Sin `ResizeObserver` (jsdom, motores viejos) mide
   una vez con `getBoundingClientRect` y vuelve a medir en `resize` de la ventana. */
import { useEffect, useState } from 'react';

export function useAnchoDeCaja(ref) {
  const [ancho, setAncho] = useState(0);
  useEffect(() => {
    const caja = ref && ref.current;
    if (!caja) return undefined;
    const medir = () => setAncho(caja.getBoundingClientRect().width || 0);
    if (typeof ResizeObserver === 'undefined') {
      medir();
      window.addEventListener('resize', medir);
      return () => window.removeEventListener('resize', medir);
    }
    const observador = new ResizeObserver((entradas) => {
      const entrada = entradas && entradas[0];
      const medida = entrada && entrada.contentRect ? entrada.contentRect.width : undefined;
      if (typeof medida === 'number') setAncho(medida); else medir();
    });
    observador.observe(caja);
    return () => observador.disconnect();
  }, [ref]);
  return ancho;
}

/** El texto corto SOLO con una medida real por debajo del umbral; con 0 (sin medir) el largo. */
export function esAngosto(ancho, umbral) {
  return ancho > 0 && ancho < umbral;
}

export default useAnchoDeCaja;
